import _get from 'lodash/get'
import _set from 'lodash/set'
import { Form, Formik, Field } from 'formik'
import React from 'react'

import Button from '../../_library/Button'
import Card from '../../_library/Card'
import { sendReferrerLink } from '../../../_common/core/http_services/brands'
import { showAxiosError } from '../../utils/messenger'
import { SimpleField } from '../../formik/Fields'
import { requiredValidator } from '../../../_common/core/validation'

function validate(data) {
  const errors = {}

  if (!validateEmail(_get(data, 'email'))) {
    _set(errors, 'email', 'Invalid Email Address')
  }

  return errors
}

export const ClientReferralForm = ({ brandId, refetch }) => (
  <Formik
    initialValues={{
      email: '',
      first_name: '',
      last_name: '',
      business_name: '',
    }}
    validate={values => validate(values)}
    onSubmit={async (values, { setSubmitting, resetForm }) => {
      try {
        await sendReferrerLink(brandId, {
          data: {
            attributes: values,
          },
        })
        resetForm()
        refetch()
      } catch (e) {
        showAxiosError(e)
      } finally {
        setSubmitting(false)
      }
    }}
  >
    {({ error, isSubmitting }) => (
      <Form>
        <Card title={'Send Referral'}>
          {!!error && (
            <div className="row">
              <div className="col-xs-12">
                <div className="alert alert-danger">{error}</div>
              </div>
            </div>
          )}
          <div className="row">
            <div className="col-sm-6 col-xs-12">
              <Field
                name="first_name"
                label="First name"
                type="text"
                component={SimpleField}
                validate={requiredValidator()}
              />
            </div>
            <div className="col-sm-6 col-xs-12">
              <Field
                name="last_name"
                label="Last name"
                type="text"
                component={SimpleField}
                validate={requiredValidator()}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6 col-xs-12">
              <Field
                name="email"
                label="Email"
                type="email"
                component={SimpleField}
                validate={requiredValidator()}
              />
            </div>
            <div className="col-sm-6 col-xs-12">
              <Field
                name="business_name"
                label="Business Name"
                type="text"
                component={SimpleField}
                validate={requiredValidator()}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              <Button type="submit" className="btn btn-primary btn-shadow" loading={isSubmitting}>
                Send
              </Button>
            </div>
          </div>
        </Card>
      </Form>
    )}
  </Formik>
)
